import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Select from 'material-ui/Select'
import { FormControl, FormHelperText } from 'material-ui/Form';
import Input, { InputLabel } from 'material-ui/Input';


const styles = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: 0,
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing.unit * 2,
    },
});
  
const RFNativeSelectField=props=>{
    const { 
        classes,
        input, label, customStyle, meta: { touched, error }, datas, codeField, descField
    } = props;

    return (
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="RFSelectField">{label}</InputLabel>
          <Select
            native
            style={customStyle}
            {...input}
            onChange={input.onChange}
            input={<Input name="rfSelectField" id="RFSelectField" />}
          >
            <option key={'code1'} value={''} /> 
            { datas.length >0 ? datas.map( data => (
                <option key={data[codeField]} value={data[codeField]}  >{data[descField]}</option>
                )) : null }

          </Select>
          <FormHelperText>{touched && error?error:''}</FormHelperText>
        </FormControl>
    )
}

RFNativeSelectField.propTypes = {
    codeField: PropTypes.string.isRequired,
    descField: PropTypes.string.isRequired
}

export default withStyles(styles)(RFNativeSelectField);


// WEBPACK FOOTER //
// ./src/components/ReduxFormComps/RFNativeSelectField.js